import { createContext, useContext, useState, useEffect } from "react";
import { getNotificationListData } from "./NotificationApi";

const NotificationContext = createContext();

export function useNotification() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = async () => {
    try {
      const userData = localStorage.getItem("userData");
      const parsedUserData = userData ? JSON.parse(userData) : null;
      const userID = parsedUserData?.userID;
      // If userID is not available, skip API call
      if (!userID) return;

      const params = { loggedInUserId: userID, PageNumber: 1, PageSize: 10 };
      const res = await getNotificationListData(params);
      const unread = (res.results || []).filter(n => !n.isRead);
      setUnreadCount(unread.length);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);

      // Optional: Redirect manually here on 401 if not caught by Axios interceptor
      // if (error.response?.status === 401) {
      //   window.location.href = "/";
      // }
    }
  };


  return (
    <NotificationContext.Provider value={{ unreadCount, fetchUnreadCount }}>
      {children}
    </NotificationContext.Provider>
  );
}